import { IconDualToneType } from "./type";

const IconBack = ({
  width = 31,
  height = 31,
  fill = "#E3232A",
  secondFill = "white",
}: IconDualToneType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.74 0H10C4.47715 0 0 4.47715 0 10V20.74C0 26.2628 4.47715 30.74 10 30.74H20.74C26.2628 30.74 30.74 26.2628 30.74 20.74V10C30.74 4.47715 26.2628 0 20.74 0Z"
        fill={fill}
      />
      <path
        d="M17.89 24.16L10.35 16.62C10.0862 16.3541 9.93817 15.9946 9.93817 15.62C9.93817 15.2454 10.0862 14.886 10.35 14.62L18.35 6.62002C18.616 6.35622 18.9754 6.20819 19.35 6.20819C19.7246 6.20819 20.084 6.35622 20.35 6.62002C20.6138 6.88599 20.7618 7.24542 20.7618 7.62002C20.7618 7.99463 20.6138 8.35406 20.35 8.62002L14.35 14.62C14.0909 14.8885 13.9462 15.247 13.9462 15.62C13.9462 15.9931 14.0909 16.3516 14.35 16.62L19.87 22.13C20.1291 22.3985 20.2739 22.757 20.2739 23.13C20.2739 23.5031 20.1291 23.8616 19.87 24.13C19.6064 24.3873 19.2543 24.5338 18.886 24.5394C18.5177 24.545 18.1613 24.4092 17.89 24.16Z"
        fill={secondFill}
      />
    </svg>
  );
};

export default IconBack;
